export default __webpack_public_path__ + "static/tv-4434381503cd42b6dfb9e1619117baca.svg";